import SendPage from './SendPage';
export default SendPage;
